<h1 mat-dialog-title class="condensed">Bestand downloaden</h1>
<div mat-dialog-content class="native-file-download-dialog">
    <mat-spinner diameter="40"></mat-spinner>
    <div>
        <div class="native-file-download-dialog__title">Even geduld...</div>
        <div class="native-file-download-dialog__filename">{{ data.filename }}</div>
    </div>
</div>
<div mat-dialog-actions>
    <div class="spacer"></div>
    <button mat-button (click)="cancel()">Annuleer</button>
</div>
